import React from "react";
import { Row, Col, Button, Modal, Checkbox, Dropdown, Menu } from 'antd'
import ExportPreview from './ExportPreview';
import HOME from "../../constants/home-constant";

const ModalExport = ({ home, dispatch }) => {

  const handleCancelCallBack = e => {
    dispatch({ type: HOME.SET_PROP, value: e.key, prop: 'exportTo' });

    dispatch({
      type: HOME.SET_PROP,
      value: true,
      prop: 'modalShow'
    });

    dispatch({
      type: HOME.SET_PROP,
      value: true,
      prop: 'previewData'
    });

    dispatch({
      type: HOME.SET_PROP,
      value: true,
      prop: 'modalShow'
    });
  }

  const menu = (
    <Menu onClick={handleCancelCallBack}>
      <Menu.Item key="0">
        <a href="#">PDF</a>
      </Menu.Item>
      <Menu.Item key="1">
        <a href="#">PNG</a>
      </Menu.Item>
    </Menu>
  );

  const footerOptionButton = (home.previewData ? [] : [
    <Button key="back" type="primary" onClick={() => handleCancelCallBack({ key: '3' })} size="small" className="text-left">
      Print
    </Button>,
    <Dropdown.Button key="dropdown" overlay={menu} type="primary" size="small" className="text-left pl-5" trigger={['click']}>
      Export as
    </Dropdown.Button>
  ]);

  const updateCheckBox = (field) => {
    dispatch({
      type: HOME.SET_PROP,
      value: !home[field],
      prop: field
    })

    dispatch({
      type: HOME.SET_PROP,
      value: true,
      prop: 'modalShow'
    })
  };

  const resetCheckBox = () => {
    ['date', 'parameter', 'description'].map((props) => { 
      dispatch({
        type: HOME.SET_PROP,
        value: false,
        prop: props
      })
    });
  }
  return (
    <Modal
      title={(home.previewData ? "Preview" : "Print/Export")}
      width={700}
      style={(home.previewData ? { top: 20 } : {})}
      visible={home.modalShow}
      onOk={() => {
          resetCheckBox();
          dispatch({ type: HOME.SET_PROP, value: true, prop: 'modalShow' });
        }
      }
      onCancel={() => {
          resetCheckBox();
          dispatch({ type: HOME.SET_PROP, value: false, prop: 'modalShow' })
        }
      }
      footer={footerOptionButton.concat([
        (<Button key="submit" type="primary" size="small" onClick={() => dispatch({ type: HOME.SET_PROP, value: false, prop: 'modalShow' })}>
          Cancel
        </Button>)
      ])}
    >
      {(home.previewData) ?
        <ExportPreview key="preview-data" home={home} dispatch={dispatch} />
        : (<Row>
          <Col span={24}>
            <p>Select Column to be Print and Export</p>
          </Col>
          <Col span={24}>
            <Row gutter={[8, 4]}>
              {/* <Col span={3}>
                <Checkbox onChange={() => updateCheckBox('date')}>Date</Checkbox>
              </Col> */}
              <Col span={6}>
                <Checkbox onChange={() => updateCheckBox('parameter')}>Parameter</Checkbox>
              </Col>
              <Col span={6}>
                <Checkbox onChange={() => updateCheckBox('description')}>Description</Checkbox>
              </Col>
              {/* <Col span={5}>
                <Checkbox onChange={() => updateCheckBox('createdBy')}>Created By</Checkbox>
              </Col> */}
            </Row>
          </Col>
        </Row>)}
    </Modal>
  )
}

export default ModalExport;